'use client';

import { useEngagementScore } from '@/hooks/useEngagementScore';

export default function EngagementTracker() {
  useEngagementScore();
  return null;
}
